import { Box, Flex, Heading, Text } from '@chakra-ui/react';

import { ButtonLink } from '~/components/button-link';
import { ContentContainer } from '~/components/container';
import { SanityImage } from '~/components/sanity-image';

import { Subcategory } from '../models/subcategory';

import { ItemCard } from './item-card';

export type CourseCollectionSectionProps = {
  title: string;
  description?: string | null;
  complimentarySubcategories: Array<
    Pick<Subcategory, 'slug' | 'pageTitle' | 'image' | 'complimentarySubcategoriesDescription'>
  >;
};

export function CourseCollectionSection({
  complimentarySubcategories,
  title,
  description,
}: CourseCollectionSectionProps) {
  return (
    <Box
      as='section'
      bgGradient='linear(180deg, #121881 0%, #171A53 100%)'
      padding={{
        base: '40px 0px',
        md: '80px 0px',
      }}
    >
      <ContentContainer
        display='flex'
        flexDirection='column'
        gap={{
          base: 8,
          md: '48px',
        }}
      >
        <Flex display='flex' flexDirection='column' gap={4}>
          <Heading
            as='h2'
            color='white'
            textAlign='center'
            size={{
              base: 'marketing-3xl',
              md: 'marketing-4xl',
            }}
          >
            {title}
          </Heading>
          {!!description && (
            <Box margin='0 auto' maxWidth='700px'>
              <Text color='white' textAlign='center'>
                {description}
              </Text>
            </Box>
          )}
        </Flex>
        <Flex
          gap={12}
          justifyContent='center'
          flexDirection={{
            base: 'column',
            md: 'row',
          }}
        >
          {complimentarySubcategories.map((subcategory) => (
            <ItemCard
              key={subcategory.slug}
              color='white'
              summary={subcategory.complimentarySubcategoriesDescription}
              summaryLinesShown={8}
              title={subcategory.pageTitle}
              buttonSlot={
                <ButtonLink
                  buttonProps={{
                    variant: 'outline',
                    width: 'fit-content',
                    onClick: () => {
                      // TODO: fire track event
                    },
                    color: 'accent.lime',
                    fill: 'accent.lime',
                    boxShadow: 'inset 0 0 0 2px #BDEA09',
                    _hover: {
                      color: 'accent.lime',
                      fill: 'accent.lime',
                    },
                  }}
                  linkProps={{
                    href: `/course-collection/${subcategory.slug}`,
                  }}
                >
                  View Course Collection
                </ButtonLink>
              }
              containerProps={{
                flex: {
                  md: '0 1 341px',
                },
              }}
              imageSlot={
                <SanityImage
                  alt=''
                  image={subcategory.image}
                  sizes='341px'
                  style={{
                    objectFit: 'cover',
                  }}
                  fill
                />
              }
            />
          ))}
        </Flex>
      </ContentContainer>
    </Box>
  );
}
